import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../app-settings';
import { AccountService } from './account.service';




@Injectable({
  providedIn: 'root'
})
export class OfftopicService {
  url = AppSettings.SERVER_URL + 'offtopic/';

  constructor(private httpClient: HttpClient, private accountService: AccountService) { }

  private readonly headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Token ${this.accountService.getSessionKey()}`,
    'accept': 'application/json'
  });

  createOfftopic(offtopic: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        this.httpClient
          .post(this.url + 'create/', offtopic, { headers })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
  }

  async getHierarchyMails(page: number = 1, searchTerm: string = '', id: number = 0, otid: number = 0): Promise<any> {
    let url = this.url;
    if (id && otid) {
      url += 'getAllEmailsByhierarchy/' + id + '/' + otid + '/';
    }
    else if (id) {
      url += 'getAllEmailsByhierarchy/' + id + '/';
    }

    else {
      url += 'getAllEmailsByhierarchy/'
    }

 //   Start with the page parameter
    let params = new HttpParams().set('page', page.toString());

    // Only add 'search' if the searchTerm is not empty
    if (searchTerm && searchTerm.trim() !== '') {
      params = params.set('search', searchTerm);  // Update params correctly
    }

    return new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        this.httpClient
          .get(url, {
            headers,
            params,
          })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
  }

  updateOffTopicReadBy(id: number): Promise<any> {
    let url = this.url + 'updateOffTopicReadBy/' + id + '/';
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        this.httpClient
          .put(url, {}, { headers })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    });
    return promise;
  }

  deleteOtThread(otid: number): Promise<any> {
    let url = this.url + 'deleteOffTopicThread/' + otid + '/';
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });
        this.httpClient.delete(url, { headers })
          .toPromise()
          .then((response) => {
            resolve(response);
          }).catch((error) => reject(error));
      });
    });
    return promise;
  }


  // to check wheather the user is admin or not 
  isAdmin(): Promise<any> {
    let url = this.url + 'isAdmin/';
    let promise = new Promise((resolve, reject) => {
      this.accountService.getSessionKey().then((key) => {
        const headers = new HttpHeaders({
          Authorization: "Token " + key,
          accept: "application/json",
        });

        this.httpClient
          .get(url, { headers })
          .toPromise()
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            console.log(error)
          });
      });
    });
    return promise;
  }

}
